import ClinicUsersPage from './clinicUsers/page'

export default function ClinicUsers() {
  return <ClinicUsersPage />
}
